import * as urlParse from 'url-parse';
import { CurrentUser } from '../general/modules/user/currentUser';
import { Url } from '../general/modules/url';
import { getUserSuid } from '../general/modules/getUserSuid';

export class DevSettingsPanel {
    private static devPanel: JQuery<HTMLDivElement>;
    private static panelDragOffset = [10, 10];

    private static storage_key = 'dev_settings_panel_collapsed';
    private static storage_value_collapsed = 0;
    private static storage_value_expanded = 1;

    public static init() {
        DevSettingsPanel.devPanel = $<HTMLDivElement>('.dev-settings-panel');

        // eslint-disable-next-line max-len
        if (parseInt(window.localStorage.getItem(DevSettingsPanel.storage_key)) === DevSettingsPanel.storage_value_expanded) {
            DevSettingsPanel.expandPanel();
        } else {
            DevSettingsPanel.collapsePanel();
        }

        DevSettingsPanel.setupListeners();
    }

    public static setupListeners() {
        const panel = DevSettingsPanel.devPanel;
        DevSettingsPanel.devPanel.on('mousedown', DevSettingsPanel.onMouseDown);
        panel.find('#current_webgl_version').on('change', DevSettingsPanel.onCurrentWebglVersionChange);
        panel.find('#current_cluster').on('change', DevSettingsPanel.onClusterChange);
        panel.find('#override_user_currency').on('change', DevSettingsPanel.onUserCurrencyChange);
        panel.find('#override_user_country').on('change', DevSettingsPanel.onUserCountryChange);
        panel.find('#override_user_continent').on('change', DevSettingsPanel.onUserContinentChange);
        panel.find('#deny_tutorial').on('change', DevSettingsPanel.onDenyTutorialChange);
        panel.find('#death_timer').on('change', DevSettingsPanel.onDeathTimerChange);
        panel.find('#suid_simulate').on('change', DevSettingsPanel.onSuidSimulateChange);
        panel.find('#test_desktop_payment').on('click', DevSettingsPanel.openDesktopPaymentWindow);
        panel.find('#live_config_branch').on('change', DevSettingsPanel.onLiveConfigBranchChange);

        panel.find('#button_collapse').on('click', DevSettingsPanel.onButtonCollapseClick);
        panel.find('#button_expand').on('click', DevSettingsPanel.onButtonExpandClick);
    }

    private static onMouseDown(event: JQuery.Event) {
        event.stopPropagation();

        DevSettingsPanel.panelDragOffset = [
            event.clientX - DevSettingsPanel.devPanel.get(0).getBoundingClientRect().left,
            event.clientY - DevSettingsPanel.devPanel.get(0).getBoundingClientRect().top
        ];

        $(document).on('mousemove', DevSettingsPanel.devPanel, DevSettingsPanel.onMouseMove);
        $(document).on('mouseup', DevSettingsPanel.onMouseUp);
    }

    private static onMouseUp(event: JQuery.Event) {
        event.stopPropagation();

        DevSettingsPanel.removeListeners();
    }

    private static removeListeners() {
        $(document).off('mousemove', DevSettingsPanel.onMouseMove);
        $(document).off('mouseup', DevSettingsPanel.onMouseUp);
    }


    private static onMouseMove(event: JQuery.Event) {
        event.stopPropagation();

        DevSettingsPanel.devPanel.css('bottom', 'unset');
        DevSettingsPanel.devPanel.css('left', event.clientX - DevSettingsPanel.panelDragOffset[0]);
        DevSettingsPanel.devPanel.css('top', event.clientY - DevSettingsPanel.panelDragOffset[1]);
    }

    private static onCurrentWebglVersionChange() {
        const currentWebglVersion = $('#current_webgl_version').val() as string;
        const url = urlParse(window.location.href, true);

        url.set('query', {
            ...url.query,
            current_webgl_version: currentWebglVersion
        });

        window.location.href = url.toString();
    }

    private static onClusterChange() {
        // const link = `${$('#current_cluster').val()}`;
        const cluster = $('#current_cluster').val() as string;
        const url = urlParse(window.location.href, true);

        url.set('query', {
            ...url.query,
            cluster
        });


        window.location.href = url.toString();
    }

    private static onUserCurrencyChange() {
        const userCurrency = $('#override_user_currency').val() as string;
        const url = urlParse(window.location.href, true);


        if (userCurrency.trim().length !== 3 && userCurrency.trim().length !== 0) {
            return;
        }

        if (userCurrency.trim().length !== 3) {
            const { user_currency: userCurrency, ...query } = url.query;
            url.set('query', query);
        } else {
            let suidSimulate: string;

            if (typeof url.query.suid_simulate === 'undefined') {
                suidSimulate = CurrentUser.getInstance().getSuid()
                    .toString();
            } else {
                suidSimulate = url.query.suid_simulate;
            }

            url.set('query', {
                ...url.query,
                suid_simulate: suidSimulate,
                user_currency: userCurrency.toUpperCase()
            });
        }

        window.location.href = url.toString();
    }

    private static onUserCountryChange() {
        const userCountry = $('#override_user_country').val() as string;
        const url = urlParse(window.location.href, true);


        if (userCountry.trim().length !== 2 && userCountry.trim().length !== 0) {
            return;
        }

        if (userCountry.trim().length !== 2) {
            const { country_code: countryCode, ...query } = url.query;
            url.set('query', query);
        } else {
            let suidSimulate: string;

            if (typeof url.query.suid_simulate === 'undefined') {
                suidSimulate = CurrentUser.getInstance().getSuid()
                    .toString();
            } else {
                suidSimulate = url.query.suid_simulate;
            }

            url.set('query', {
                ...url.query,
                country_code: userCountry.toUpperCase(),
                suid_simulate: suidSimulate
            });
        }

        window.location.href = url.toString();
    }

    private static onUserContinentChange() {
        const userContinent = $('#override_user_continent').val() as string;
        const url = urlParse(window.location.href, true);


        if (userContinent.trim().length !== 2 && userContinent.trim().length !== 0) {
            return;
        }

        if (userContinent.trim().length !== 2) {
            const { continent_code: continentCode, ...query } = url.query;
            url.set('query', query);
        } else {
            let suidSimulate: string;

            if (typeof url.query.suid_simulate === 'undefined') {
                suidSimulate = CurrentUser.getInstance().getSuid()
                    .toString();
            } else {
                suidSimulate = url.query.suid_simulate;
            }

            url.set('query', {
                ...url.query,
                suid_simulate: suidSimulate,
                continent_code: userContinent.toUpperCase()
            });
        }

        window.location.href = url.toString();
    }

    private static onSuidSimulateChange() {
        const suidSimulate = $('#suid_simulate').val() as string;
        const url = urlParse(window.location.href, true);

        if (suidSimulate.trim().length === 0) {
            const { suid_simulate: suidSimulate, ...query } = url.query;
            url.set('query', query);
        } else {
            url.set('query', {
                ...url.query,
                suid_simulate: suidSimulate.toLowerCase()
            });
        }

        window.location.href = url.toString();
    }

    private static onDenyTutorialChange() {
        const isDeny = $('#deny_tutorial').prop('checked');
        const url = urlParse(window.location.href, true);

        if (isDeny) {
            url.set('query', {
                ...url.query,
                deny_tutorial: 1
            });
        } else {
            const { deny_tutorial: denyTutorial, ...query } = url.query;
            url.set('query', query);
        }
        window.location.href = url.toString();
    }

    private static onDeathTimerChange() {
        const isDeny = $('#death_timer').prop('checked');
        const url = urlParse(window.location.href, true);

        if (isDeny) {
            url.set('query', {
                ...url.query,
                death_timer: 1
            });
        } else {
            const { death_timer: deathTimer, ...query } = url.query;
            url.set('query', query);
        }
        window.location.href = url.toString();
    }

    private static onLiveConfigBranchChange() {
        const branch = $('#live_config_branch').val() as string;
        const url = urlParse(window.location.href, true);

        if (branch.trim().length === 0) {
            const { live_config_branch: branch, ...query } = url.query;
            url.set('query', query);
        } else {
            url.set('query', {
                ...url.query,
                live_config_branch: branch
            });
        }

        window.location.href = url.toString();
    }

    private static async openDesktopPaymentWindow() {
        const suid = getUserSuid();
        const token = window.app.config.user_auth_token;
        const language = window.app.config.language;
        const win = window.open(
            `${Url.getNoLangUrl('desktop/orderBox')}?suid=${suid}&token=${token}&language=${language}`,
            'desktop pay',
            'width=700,height=700'
        );
        let checkInterval: number;
        await new Promise<void>((resolve) => {
            checkInterval = window.setInterval(
                () => {
                    if (win.app) {
                        window.clearInterval(checkInterval);
                        resolve();
                    }
                },
                500
            );
        });

        const currentPaymentObject = Object.keys(window.app?.last_payment_object).length &&
            window.app?.last_payment_object ||
            null;
        const paymentObject = currentPaymentObject ??
            {
                id: 34060,
                reward: [],
                pic: '',
                currency: 'PLN',
                description: '',
                name: 'Абсолютное превосходство',
                price: 30000,
                guid_receiver: window.app.getGameStartDataResponse.guid
            };
        win.gameInstance = window.gameInstance;
        win.order_box_ready = function fakeOrderBoxReady() {
            console.log('desktop order box ready');
        };
        win.close_order_box = function closeDevOrderBox() {
            win.close();
            window.app.game_popup_close();
        };
        win.pay_finish = window.app.payFinish;

        const callPayInterval = setInterval(()=>{
            // @ts-ignore
            win.app.pay(JSON.stringify(paymentObject));
            clearInterval(callPayInterval);
        }, 1000);
    }

    private static onButtonCollapseClick() {
        DevSettingsPanel.collapsePanel();
        window.localStorage.setItem(DevSettingsPanel.storage_key, DevSettingsPanel.storage_value_collapsed.toString());
    }

    private static onButtonExpandClick() {
        DevSettingsPanel.expandPanel();
        window.localStorage.setItem(DevSettingsPanel.storage_key, DevSettingsPanel.storage_value_expanded.toString());
    }

    private static collapsePanel() {
        const content = DevSettingsPanel.devPanel.find('.dev-settings-content');
        content.hide();
        DevSettingsPanel.devPanel.find('#button_collapse').hide();
        DevSettingsPanel.devPanel.find('#button_expand').show();
    }

    private static expandPanel() {
        const content = DevSettingsPanel.devPanel.find('.dev-settings-content');
        content.show();
        DevSettingsPanel.devPanel.find('#button_collapse').show();
        DevSettingsPanel.devPanel.find('#button_expand').hide();
    }
}
